<template>
    <div>
        <!-- Footer -->
        <div
            class="footer mt-3"
            :class="isMobile ? 'footer-sm' : 'footer-lg'"
            v-if="$route.path !== '/maung-fb' && $route.path !== '/body-fb'"
        >
            <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
            <div class="align-items-center justify-content-lg-between">
                <div class="col-lg-12 text-center">
                    <ul class="nav nav-footer justify-content-between">
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/home') }"
                            @click="$router.push('/home')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/home.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('footer.home') }}
                                </div>
                            </div>
                        </li>
                        <!-- <li
                            class="nav-item"
                            @click="openModal()"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="/build/assets/img/icons/Download.png" style="width: 18px; height: 18px" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #a486ea;">
                                    {{
                                        $store.state.language === "en"
                                            ? "Download"
                                            : "ဒေါင်းလုတ်"
                                    }}
                                </div>
                            </div>
                        </li> -->
                        <!-- :class="linkIsActive('/deposit') ? 'active' : ''" -->
                        
                        <!-- <li
                            class="nav-item"
                            @click="$router.push('/history')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img class="mx-auto" src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/money-exchange%20(1).png" style="width: auto; height: 1.5rem;" alt="">
                                <div class="mx-auto pt-1 text-sm" style="color: #000000;">
                                    {{$t('setting.transaction')}}
                                </div>
                            </div>
                        </li> -->
                        <li
                            class="nav-item footer-deposit-cta"
                            :class="{
                                active: linkIsActive('/deposit'),
                                'footer-deposit-cta--pulse': !linkIsActive('/deposit') && !depositPulsePaused,
                            }"
                            @click="onDepositClick"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/wallet.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('setting.deposit') }}
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/withdraw') }"
                            @click="$router.push('/withdraw')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/withdraw.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('setting.withdraw') }}
                                </div>
                            </div>
                        </li>
                        <!-- <li class="nav-item">
                            <a
                                href="https://t.me/Shwekyarphyu168_Bot"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <div class="d-flex flex-column banking-icons">
                                    <img
                                        class="mx-auto footer-nav-icon"
                                        src="https://storage.googleapis.com/spacetech2/shwemyanmar/customer-support.png"
                                        alt=""
                                    >
                                    <div class="mx-auto pt-1 text-sm footer-nav-label">
                                        {{ $t('setting.customer_service') }}
                                    </div>
                                </div>
                            </a>
                        </li> -->
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/promotion') }"
                            @click="$router.push('/promotion')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/marketing.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('footer.promotion') }}
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item"
                            :class="{ active: linkIsActive('/setting') }"
                            @click="$router.push('/setting')"
                        >
                            <div class="d-flex flex-column banking-icons">
                                <img
                                    class="mx-auto footer-nav-icon"
                                    src="https://storage.googleapis.com/spacetech2/shwemyanmar/settings.png"
                                    alt=""
                                >
                                <div class="mx-auto pt-1 text-sm footer-nav-label">
                                    {{ $t('footer.profile') }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog } from 'vant';

export default {
    data() {
        return {
            is_live: false,
            isMobile: false,
            depositPulsePaused: false,
        };
    },
    methods: {
        closeModal() {
            $('#download-modal').modal('hide');
        },
        openModal() {
            $('#download-modal').modal('show');
        },
        /* example link = '/settings' */
        linkIsActive(link) {
            if (link === '/home') {
                return this.$route.path === '/' || this.$route.path === '/home';
            }
            return this.$route.path === link;
        },
        onDepositClick() {
            this.depositPulsePaused = true;
            this.$router.push('/deposit');
        },
        updateViewport() {
            this.isMobile = window.innerWidth < 768;
        },
        async fetchFootballLive() {
            try {
                const res = await axios.get('/football-lives');
                this.is_live = res.data.data[0].is_live;
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.fetchFootballLive();
        this.updateViewport();
        window.addEventListener('resize', this.updateViewport);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateViewport);
    },
};
</script>
<style scoped>
.modal-content {
    border: 2px solid #00a82d;
}

td .fa-trash {
    color: #00f23d;
}

.modal-cross {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    padding-top: 3px;
    margin-left: auto;
    color: white;
    cursor: pointer;
    margin-right: -9px;
    margin-top: -9px;
    background: linear-gradient(135deg, #00a82d 0%, #00f23d 100%);
}

.banking-icons {
    width: auto;
    height: auto;
    padding: 5px;
    border-radius: 5px;
}

.bet-container {
    position: fixed;
    bottom: 0;
    margin-bottom: 50px;
    width: 50px;
    /* right: 0; */
    left: 5px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.25em;
    color: white;
    z-index: 100;
    visibility: visible;
    opacity: 1;
}

.nav-item {
    position: relative;
    flex: 1;
    font-size: 1rem;
    cursor: pointer;
    font-weight: 600;
    min-width: 0;
}

/* PNG icons → neon green on dark footer */
.footer-nav-icon {
    width: auto;
    height: 1.35rem;
    opacity: 0.65;
    filter: brightness(0) invert(1);
    transition: transform 0.2s ease, opacity 0.2s ease, filter 0.2s ease;
}

/* Beat Argon `.footer .nav .nav-item .nav-link` and other globals */
.footer ul.nav-footer .nav-item,
.footer ul.nav-footer .nav-item .footer-nav-label,
.footer ul.nav-footer .nav-item .banking-icons,
.footer ul.nav-footer .nav-item a,
.footer ul.nav-footer .nav-item a:visited,
.footer ul.nav-footer .nav-item a .footer-nav-label {
    color: rgba(241, 255, 245, 0.62) !important;
    text-decoration: none !important;
}

.footer-nav-label {
    font-size: 0.65rem !important;
    font-weight: 600;
    line-height: 1;
    transition: color 0.2s ease;
}

.footer ul.nav-footer .nav-item.active .footer-nav-label {
    color: #00f23d !important;
}

.footer .nav-item.active .footer-nav-icon {
    opacity: 1;
    filter: brightness(0) saturate(100%) invert(68%) sepia(74%) saturate(1200%) hue-rotate(75deg) brightness(1.12) contrast(1.05);
    transform: translateY(-2px);
}

.footer .nav-item.active::before {
    position: absolute;
    top: -1px;
    left: 50%;
    width: 1.7rem;
    height: 3px;
    border-radius: 0 0 999px 999px;
    background: linear-gradient(90deg, #00a82d, #00f23d, #00a82d);
    box-shadow: 0 2px 10px rgba(0, 242, 61, 0.55);
    content: "";
    transform: translateX(-50%);
}

.footer ul.nav-footer .nav-item a:hover,
.footer ul.nav-footer .nav-item a:hover .footer-nav-label {
    color: #f1fff5 !important;
}

.footer {
    bottom: 0;
    height: 4.15rem !important;
    width: 100%;
    background:
        radial-gradient(circle at 50% 0%, rgba(0, 242, 61, 0.18), transparent 42%),
        linear-gradient(180deg, rgba(15, 36, 23, 0.98) 0%, rgba(6, 17, 11, 0.99) 100%);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    box-shadow: 0 -6px 22px rgba(0, 0, 0, 0.38);
    border-top: 1px solid rgba(0, 242, 61, 0.35);
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
}

.footer-sm,
.footer-lg {
    /* Stay inside the centered phone shell on PC (not full viewport) */
    position: absolute;
    left: 0;
    right: 0;
}

@media (max-width: 767.98px) {
    .footer-sm {
        position: fixed;
    }
}

.banking-icons {
    width: auto;
    height: auto;
    padding: 0.2rem;
    padding-top: 0.55rem;
    padding-bottom: 0.4rem;
    border-radius: 3px;
    transition: transform 0.2s ease;
}

.nav-item:active .banking-icons {
    transform: scale(0.94);
}

.footer {
    padding: 1px !important;
}

/* Soft deposit heartbeat — draws attention without shaking the whole bar */
.footer-deposit-cta--pulse .footer-nav-icon {
    animation: footer-deposit-heartbeat 2.8s ease-in-out infinite;
}

.footer-deposit-cta--pulse .footer-nav-label {
    color: rgba(0, 242, 61, 0.85) !important;
}

.footer-deposit-cta--pulse::after {
    position: absolute;
    top: 0.35rem;
    left: 50%;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 50%;
    background: rgba(0, 242, 61, 0.22);
    content: "";
    transform: translateX(-50%);
    animation: footer-deposit-ring 2.8s ease-out infinite;
    pointer-events: none;
    z-index: 0;
}

.footer-deposit-cta .banking-icons {
    position: relative;
    z-index: 1;
}

@keyframes footer-deposit-heartbeat {
    0%,
    100% {
        transform: scale(1);
        opacity: 0.75;
        filter: brightness(0) invert(1);
    }

    40% {
        transform: scale(1.12);
        opacity: 1;
        filter: brightness(0) saturate(100%) invert(68%) sepia(74%) saturate(1200%) hue-rotate(75deg) brightness(1.12) contrast(1.05);
    }

    55% {
        transform: scale(1.04);
        opacity: 1;
        filter: brightness(0) saturate(100%) invert(68%) sepia(74%) saturate(1200%) hue-rotate(75deg) brightness(1.12) contrast(1.05);
    }
}

@keyframes footer-deposit-ring {
    0% {
        opacity: 0.55;
        transform: translateX(-50%) scale(0.7);
    }

    70% {
        opacity: 0;
        transform: translateX(-50%) scale(1.9);
    }

    100% {
        opacity: 0;
        transform: translateX(-50%) scale(1.9);
    }
}

@media (prefers-reduced-motion: reduce) {
    .footer-deposit-cta--pulse .footer-nav-icon,
    .footer-deposit-cta--pulse::after {
        animation: none !important;
    }
}

/* .banking-icons img {
        width: 25px;
        height: 25px;
        border-radius: 3px;
    } */
/* } */
</style>
